// src/screens/payment/PaymentError.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PaymentError.css';

const PaymentError = () => {
  const navigate = useNavigate();

  return (
    <div className="payment-error-container">
      <div className="payment-error-card">
        <div className="icon-error">✖</div>
        <h1>Ödəniş Uğursuz Oldu</h1>
        <p>Bağışlayın! Ödəniş zamanı xəta baş verdi. Zəhmət olmasa, yenidən cəhd edin və ya bizimlə əlaqə saxlayın.</p>
        <button className="go-home-btn" onClick={() => navigate('/')}>
          Ana səhifəyə qayıt
        </button>
      </div>
    </div>
  );
};

export default PaymentError;
